import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import moment from 'moment';
import { DateRangePicker } from 'app/ComponentLibrary/DateRangeNew';
import { startDateModStyles } from '../../StartDate/StartDateMod.styles';
import { useDispatch, useSelector } from 'react-redux';
import { selectEditTimeOffRows, selectTimeOffStartDateError } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { differenceInDays, isBefore, isValid } from 'date-fns';
import { findIndex, findRow } from './TimeOffHours';


export const StartDateEditCell = (cellParams: any) => {
  return <NewStartDate cellParams={cellParams} />;
};

const NewStartDate = React.memo(function NewStartDate(cellParams: any) {
  const { classes } = startDateModStyles();
  const { control } = useFormContext();
  const dispatch = useDispatch();
  const RowId = cellParams?.cellParams?.id;
  const [startDateState, setStartDate] = useState(cellParams?.cellParams?.row?.startDate);
  const timeOffEditRequests = useSelector(selectEditTimeOffRows);
  const timeOffStartDateErrors = useSelector(selectTimeOffStartDateError);
  const setDateForTimeOffEdit = date => {
    let newRow = timeOffEditRequests.slice(0);

    let timeOffEditRow = findRow(cellParams, timeOffEditRequests, RowId);

    const daysDiff =
      !isValid(new Date(date)) || isBefore(new Date(cellParams?.cellParams?.row?.endDate), new Date(date))
        ? null
        : differenceInDays(new Date(cellParams?.cellParams?.row?.endDate), new Date(date)) + 1;
    let updatedStartDate = {};
    updatedStartDate = {
      ...timeOffEditRow,
      startDate: date,
      days: daysDiff ? daysDiff : '--',
    };

    let editDateIndex = findIndex(updatedStartDate, cellParams, timeOffEditRequests, RowId);

    newRow[editDateIndex] = updatedStartDate;
    dispatch(placementModsAction.setEditTimeOffRows(newRow));
    dispatch(placementModsAction.setGridModAltered(true));
  };

  useEffect(() => {
    if (cellParams?.cellParams?.error !== null && cellParams?.cellParams?.error !== undefined) {
      const val = timeOffStartDateErrors?.filter(el => el.id === cellParams?.cellParams?.id);

      if (val?.length === 0) {
        const arr = timeOffStartDateErrors?.length > 0 ? timeOffStartDateErrors?.slice(0) : [];
        const valueObj = { startDate: cellParams?.cellParams?.error, id: cellParams?.cellParams?.id };

        arr.push(valueObj);

        dispatch(placementModsAction.setTimeOffStartDateError(arr));
      } else {
        const arr = timeOffStartDateErrors?.slice(0);
        let currentObj = arr.find(val => val.id === cellParams?.cellParams?.id);

        let updatedObj = { ...currentObj, startDate: cellParams?.cellParams?.error };

        let editIndex = arr.findIndex(val => val.id === cellParams?.cellParams?.id);

        arr[editIndex] = updatedObj;

        dispatch(placementModsAction.setTimeOffStartDateError(arr));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cellParams?.cellParams?.error]);

  return (
    <Controller
      control={control}
      name={`timeOffRequests[${RowId}].startDate`}
      render={({ field: { onChange, ...rest } }) => {
        return (
          <React.Fragment>
            <DateRangePicker
              onChange={newValue => {
                if (newValue.startDate !== undefined) {
                  const newDate = moment(newValue.startDate);
                  const setTo = newDate.isValid() ? moment(newDate).format('YYYY-MM-DDTHH:mm:ss') : null;
                  onChange(setTo);
                  setDateForTimeOffEdit(setTo);
                  setStartDate(setTo);
                } else {
                  onChange(null);
                  setDateForTimeOffEdit(null);
                }
              }}
              onCancel={() => { }}
              value={cellParams?.cellParams?.row?.startDate}
              variant="filled"
              single
              quickSelect={false}
              useMaxWidth={true}
              showIcon={true}
              className={startDateState ? classes.inputFieldNoLabel : classes.inputFields}
              labelClass={startDateState ? classes.hideInputFieldLabel : classes.inputFields}
              actionBar={false}
              clickAway={true}
              trailingIconShow={true}
              keepClickAwayVal={true}
              initialDateRange={{
                startDate:
                  cellParams?.cellParams?.row?.startDate && cellParams?.cellParams?.row?.startDate !== '--'
                    ? new Date(cellParams?.cellParams?.row?.startDate)
                    : undefined,
                endDate:
                  cellParams?.cellParams?.row?.startDate && cellParams?.cellParams?.row?.startDate !== '--'
                    ? new Date(cellParams?.cellParams?.row?.startDate)
                    : undefined,
                useLabelAsValue: true,
              }}
            />
          </React.Fragment>
        );
      }}
    />
  );
});
